import { render, staticRenderFns } from "./carlistcom.vue?vue&type=template&id=2bd91614&scoped=true&"
import script from "./carlistcom.vue?vue&type=script&lang=js&"
export * from "./carlistcom.vue?vue&type=script&lang=js&"
import style0 from "./carlistcom.vue?vue&type=style&index=0&id=2bd91614&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd91614",
  null
  
)

export default component.exports